/**
 * @generated SignedSource<<f22af740b9f01c682edfdefc362f65da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "order",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Locker",
        "kind": "LinkedField",
        "name": "deliveryLocker",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockerType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CoverDeliveryModalQuery",
    "selections": (v1/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CoverDeliveryModalQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fbf86b95e1432f3dba8b2ddc6521d928",
    "id": null,
    "metadata": {},
    "name": "CoverDeliveryModalQuery",
    "operationKind": "query",
    "text": "query CoverDeliveryModalQuery(\n  $id: Int!\n) {\n  order(id: $id) {\n    id\n    rowId\n    deliveryLocker {\n      name\n      lockerType\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6b26c056d839e743ca623bffdae134a0";

module.exports = node;
